import { render, staticRenderFns } from "./SendDocumentPdfSelectModal.vue?vue&type=template&id=2ff9eccd&scoped=true&lang=pug"
import script from "./SendDocumentPdfSelectModal.vue?vue&type=script&lang=ts"
export * from "./SendDocumentPdfSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentPdfSelectModal.vue?vue&type=style&index=0&id=2ff9eccd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9eccd",
  null
  
)

export default component.exports